import axios from 'axios';
import QueryString from 'qs';
import { z } from 'zod';

import { apiRoutes, StripeCollectionDataZodSchema } from './config';

const paramsSerializer = {
  serialize: (params: Record<string, unknown>) =>
    QueryString.stringify(params, { encodeValuesOnly: true }),
};

const navigationVerticalSchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  navigationLabel: z.string().nullish(),
});

const navigationIndustrySchema = z.object({
  id: z.number(),
  name: z.string(),
  slug: z.string(),
  navigationLabel: z.string().nullish(),
  navigationDescription: z.string().nullish(),
  verticals: z.array(navigationVerticalSchema).nullish(),
});
export type NavigationIndustry = z.infer<typeof navigationIndustrySchema>;

export const getIndustriesForNavigation = async () => {
  const { data } = await axios.get(apiRoutes.industries._root, {
    params: {
      fields: ['name', 'slug', 'navigationLabel', 'navigationDescription'],
      populate: {
        verticals: {
          fields: ['title', 'slug', 'navigationLabel'],
        },
      },
      pagination: { limit: 100 },
    },
    paramsSerializer,
  });

  return StripeCollectionDataZodSchema(navigationIndustrySchema).parse(data)
    .data;
};
